import styled from "styled-components";

export const StyledListItem = styled.li`
  padding: 8px 4px 8px 10px;
  border: 1px solid #e9e9e9;
  border-radius: 6px;
  margin-bottom: 3px;
  display: flex;
  justify-content: space-between;

  span {
    padding-left: 8px;
  }

  &:hover {
    border-color: #c7c8c9;
  }
`;

export const StyledTitle = styled.div`
  display: flex;
  align-items: center;
`;

export const StyledButtonSection = styled.div`
  display: flex;
  width: 270px;
  justify-content: space-between;

  button {
    width: 90px;

    :hover {
      color: #2e3538 !important;

      &.replace {
        svg {
          fill: rgba(255, 87, 87, 1) !important;
        }
      }
      &.append {
        svg {
          fill: rgba(58, 134, 255, 1) !important;
        }
      }
    }
  }
  span {
    padding-left: 5px;
    text-align: center;
  }
  .ignore {
    span {
      width: 100%;
    }
  }

  .is-disabled {
    background: transparent !important;
    border-color: transparent !important;
  }
  .is-active {
    color: #2e3538 !important;
    &.replace {
      background: rgba(254, 236, 238, 0.5) !important;
      border-color: rgba(255, 87, 87, 0.2) !important;
      svg {
        fill: rgba(255, 87, 87, 1) !important;
      }
    }
    &.append {
      background: rgba(231, 240, 254, 0.5) !important;
      border-color: rgba(58, 134, 255, 0.2) !important;
      svg {
        fill: rgba(58, 134, 255, 1) !important;
      }
    }
    &.ignore {
      background: rgba(243, 243, 244, 1) !important;
      border-color: rgba(222, 222, 222, 1) !important;
    }
  }
`;
